module.exports = __webpack_public_path__ + "static/img/logo_SF.3fdfd9f3.png";